import _ from "underscore";
import stores from "../../../stores";
import C from "../constants";
const {QUOTES_RELATED_SNAPSHOT} = C;

let singleton;

const storesAndImportantAttrsMap = [
  {
    storeName: "AsnStore",
    listenables: ["asns:change"],
    callOnEvent: "asnStoreChanged",
    only: [
      // Location Tab Info 
      "facilities",
      "cadId",
      "cadAddress1",
      "cadAddress2",
      "cadCountry",
      "cadCity",
      "state",
      "cadZipcode",
      "cadStateText",
      // Shipping Tab Info
      "shippingPartner",
      // don't need inbound carrier
      // "inboundCarrier",
      "insidePickup",
      "liftGatePickup",
      "limitedAccess",
      "lumperPickup",
      "driverLoad",
      "pickupDate",
      "pickupTimeFrom",
      "pickupTimeTo",
      "shippingMethod",
    ]
  },
  {
    storeName: "AsnDetailStore",
    listenables: ["asn_details:change", "asn_details:add", "asn_details:remove"],
    callOnEvent: "asnDetailStoreChanged"
  }
];


export default function shippingQuotesInvalidatorFactory(options){
  if(singleton){
    // singleton.setOptions(options);
    return singleton;
  }
  else{
    singleton = new ShippingQuotesInvalidator(options);
    singleton.init();
    return singleton;
  }
}

function ShippingQuotesInvalidator(){
  const self = this;

  this.init = function(){
    bindStores();
  }

  const eventCallables = {
    asnStoreChanged,
    asnDetailStoreChanged
  }

  function bindStores(){
    _(storesAndImportantAttrsMap).map(bindStoreViaMap);
  }

  function bindStoreViaMap(storeConfig){
    const {storeName, listenables, callOnEvent} = storeConfig;
    _(listenables).map((listenable)=>{
      stores[storeName].bindListener(listenable, _.partial(eventCallables[callOnEvent], storeConfig));
    });   
  }


  function asnStoreChanged(storeConfig){
    // console.log('asn store changed');
    const {only} = storeConfig;
    const asn = getCurrentAsn();
    const asnId = asn.id;

    // check if quote are not already invalidated, AND (that we actually have quotes OR specialQuote flag is true), AND we have a snapshot, and that there are changes since the last snapshot
    if(!AsnStore.areQuotesInvalid(asn) && (hasQuotes(asn) || hasSpecialQuote(asn)) && AsnStore.getDataSnapshotViaTag(QUOTES_RELATED_SNAPSHOT) && AsnStore.hasDataChangesSinceSnapshotViaTag(QUOTES_RELATED_SNAPSHOT, {id: asnId, only})){
      console.log("invalidating quotes flag set");
      AsnStore.updateObjectAndEmit(asnId, {quotesAreValid: false, showQuotesRemovedBecauseInfoChangedMessage: true});
    }
  }

  function asnDetailStoreChanged(storeConfig){
    // console.log('asn detail store changed');
    const asn = getCurrentAsn();
    const asnId = asn.id;

    if(!AsnStore.areQuotesInvalid(asn) && (hasQuotes(asn) || hasSpecialQuote(asn)) && AsnDetailStore.getDataSnapshotViaTag(QUOTES_RELATED_SNAPSHOT) && AsnDetailStore.hasDataChangesSinceSnapshotViaTag(QUOTES_RELATED_SNAPSHOT)){
      console.log("invalidating quotes flag set");
      AsnStore.updateObjectAndEmit(asnId, {quotesAreValid: false, showQuotesRemovedBecauseInfoChangedMessage: true});
    }
  }

  function hasSpecialQuote(asn){
    return AsnStore.hasSpecialQuote(asn);
  }

  function hasQuotes(asn){
    let q = AsnStore.getAvailableAndSelectedQuotesForAsn(asn);
    if(q && q.length){
      return true;
    }
    q = AsnStore.getSelectedQuoteForAsn(asn);
    if(!_.isNull(q) && !_.isUndefined(q)){
      return true;
    }

    return false;
  }

  function getCurrentAsnId(){
    return getCurrentAsn().id;
  }

  function getCurrentAsn(){
    return AsnStore.getAsnWithShippingMethod();
  }

}


// WEBPACK FOOTER //
// ./src/pages/asns/businessLogic/shippingQuotesInvalidatorFactory.js